import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import { LoanUsesInner } from './components/LoanUsesInner';
import { LoanUsesVariation } from './types';

export type LoanUsesProps = SliceComponentProps<Content.LoanUsesSlice>;

const LoanUses = ({ slice }: LoanUsesProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <LoanUsesInner
        data={slice.primary}
        variation={slice.variation as LoanUsesVariation}
      />
    </section>
  );
};

export default LoanUses;
